import React, {Component} from 'react'
import {MDCDDateInput} from "./MDCDateInput"
import {dateOnlyFormat, dateTime24HrFormat, dateTime24HrNoTzFormat} from "../../utils/util"

const momentPromise = import(/* webpackChunkName: "momentTimezone" */ "moment-timezone")
let moment

export class TargetPickupDateRenderer extends Component {

  constructor(props) {
    super(props)
    this.waitForImports()
  }

  async waitForImports() {
    moment = (await momentPromise).default
    this.setState(this.extractStateFromData(this.props.data))
  }

  extractStateFromData(data) {
    return {
      targetPickupDate: data.targetPickupDt || '',
      minDate: this.calculateMinPickerDateLocal(data)
    }
  }

  calculateMinPickerDateLocal(data) {
    // picker only understands local dates.  Keep it local to keep it simple
    // min date rule: max of: (min of: (DEM LFD + 1) vs (RMC LFD + 1)) vs (Today)
    const {lastFreeDt, lastRmcFreeDt} = data
    if (!lastFreeDt) {
      return null
    }
    let minLocalDate = moment(lastFreeDt, dateOnlyFormat).add(1, 'days').toDate()
    if (lastRmcFreeDt) {
      const rmcLfd = moment(lastRmcFreeDt, dateOnlyFormat).add(1, 'days').toDate()
      if (rmcLfd < minLocalDate) {
        minLocalDate = rmcLfd
      }
    }
    const now = moment().toDate()
    if (minLocalDate < now) {
      minLocalDate = now
    }
    return minLocalDate
  }

  handleValueChange(event) {
    let targetPickupDate = event.target.value
    const pickupMoment = this.convertStringToTargetPickupMoment(targetPickupDate)
    if (pickupMoment.isValid()) {
      let newDate = pickupMoment.toDate()
      if (newDate >= this.state.minDate) {
        targetPickupDate = moment(newDate).format(dateOnlyFormat)
        setTimeout(this.props.stopEditing, 10)
      }
    }
    this.setState({targetPickupDate: targetPickupDate})
  }

  isDateValid() {
    const momentDate = this.convertStringToTargetPickupMoment(this.state.targetPickupDate)
    if (!momentDate.isValid()) {
      return false
    }
    return momentDate.toDate() >= this.state.minDate
  }

  convertStringToTargetPickupMoment(pickupString) {
    const trimmedDateTime = (pickupString || '').trim()
    const momentDate = moment(trimmedDateTime, [dateTime24HrNoTzFormat, 'MM/DD/YY'], true)
    if (momentDate.isValid()) {
      momentDate.set({hour: 23, minute: 59})
    }
    return momentDate
  }

  getValue() {
    return this.state.targetPickupDate
  }

  getDefaultTime() {
    return moment().endOf('day').toDate()
  }

  calculateDatePickerTopPosition() {
    const querySelector = `.ag-center-cols-viewport div[role="row"][row-index="${this.props.node.rowIndex}"] div[col-id="targetPickupDt"]`
    const currentDatePicker = document.querySelector(querySelector)
    const offset = this.props.pickerOffset !== undefined ? this.props.pickerOffset : 31
    return currentDatePicker.getBoundingClientRect().top + offset
  }

  render() {
    if (!moment || !this.state) {
      return null
    }
    return <div ref={elem => this.datepicker = elem} style={{width: 100}}>
      <MDCDDateInput
          value={this.state.targetPickupDate.substr(0, 8)}
          inputClassName="target-pickup-date"
          textClassName="target-pickup-date"
          showTimeInput={false}
          isValid={this.isDateValid()}
          dense={true}
          minDate={this.state.minDate}
          onChange={this.handleValueChange.bind(this)}
          disabledKeyboardNavigation={true}
          dateFormat={dateTime24HrFormat}
          closeOnSelect={true}
          showPicker={true}
          defaultTime={this.getDefaultTime()}
          position={this.calculateDatePickerTopPosition()}
          endOfDay={true}
          takeFocus={true}
      />
    </div>
  }

  refresh(params) {
    this.setState(this.extractStateFromData(params.data))
    return true
  }

  isCancelAfterEnd() {
    return !this.isDateValid()
  }
}